import { render, staticRenderFns } from "./AdminGroupDelete.vue?vue&type=template&id=6b73bd7a&scoped=true"
import script from "./AdminGroupDelete.vue?vue&type=script&lang=js"
export * from "./AdminGroupDelete.vue?vue&type=script&lang=js"
import style0 from "./AdminGroupDelete.vue?vue&type=style&index=0&id=6b73bd7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b73bd7a",
  null
  
)

export default component.exports